export const MODALS = {
  PRODUCT_DETAIL: 'productDetail',
  EDIT_PRODUCT: 'editProduct',
  REPEAT_ORDER: 'repeatOrder',
  DELIVERY_OR_PICKUP: 'deliveryOrPickup',
  CONFIRMATION_ORDER: 'confirmationOrder',
  ORDER_CREATION_STATUS: 'orderCreationStatus',
  MINI_CART: 'miniCart',
  PROFILE_MENU: 'profileMenu',
  LOGIN: 'login',
  SESSION_CLOSED: 'sessionClosed',
  ORDER_DETAILS: 'orderDetails',
  ANNUL_ORDER: 'annulOrder',
  NEW_ORDERS: 'newOrders',
  SETTINGS: 'settings',
  INJECT_ORDER: 'injectOrder',
  CREATE_ORDER: 'createOrder'
};

export const ADD_ADDRESS_MODAL = 'addAddress';
export const STORE_CLOSED = 'storeClosed';
export const CHANGE_ADDRESS = 'changeAddress';
